import {
  MULTI_QUESTION_LOGIC_JUMP_TYPES,
  MULTI_QUESTION_TYPES,
} from "../../../../../api/questionnaires/config";
import { NodeId } from "../../utilities";

export const INITIAL_IF_LOGIC_JUMP = {
  type: MULTI_QUESTION_LOGIC_JUMP_TYPES.jump,
  ifSelectedChoiceId: null,
  thenQuestionId: null,
};

export const INITIAL_ELSE_LOGIC_JUMP = {
  type: MULTI_QUESTION_LOGIC_JUMP_TYPES.else,
  elseQuestionId: null,
};

export const QUESTION_TYPES_WITH_LOGIC_JUMPS = [
  MULTI_QUESTION_TYPES.yesNo,
  MULTI_QUESTION_TYPES.singleChoice,
  MULTI_QUESTION_TYPES.opinionScale,
];

export const QUESTION_TYPES_WITH_CHOICES = [
  MULTI_QUESTION_TYPES.singleChoice,
  MULTI_QUESTION_TYPES.multiChoice,
];

export const DEFAULT_QUESTION_TYPE = MULTI_QUESTION_TYPES.textBox;

export const YES_NO_CHOICES = [
  {
    id: NodeId.make(),
    value: "Yes",
  },
  {
    id: NodeId.make(),
    value: "No",
  },
];

export const OPINION_SCALE_CHOICES = Array.from(Array(10).keys()).map((i) => ({
  id: NodeId.make(),
  value: String(i + 1),
}));

export const INITIAL_LOGIC_JUMPS = [
  INITIAL_IF_LOGIC_JUMP,
  INITIAL_ELSE_LOGIC_JUMP,
];
